export default __webpack_public_path__ + "static/media/cert-ngo-hkgcsmeaa.95632206.jpg";